import { createEntityAdapter, createSlice, EntityState, PayloadAction } from "@reduxjs/toolkit";
import { isEqual, keyBy, merge } from "lodash";

import Graph_QL, { DynamicDataObk } from "../..";
import { AnimalInfo } from "../GQLCalls/getAnimalCall";

export type AnimalItem = DynamicDataObk<AnimalInfo[]>

const animalsDataAdapter = createEntityAdapter({
  selectId: (item: AnimalItem) => Graph_QL.ObjToString(item.con)
});

const mergePayloadAndState = (state: EntityState<AnimalItem, string>, {con, data}: AnimalItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const existingData = state.entities[identifier].data;
    const dataDictionary = keyBy(state.entities[identifier].data, "animal_id")
    //TODO: CTO consider if merging all values might result in data discrepancy
    data.forEach((entry) => dataDictionary[entry.animal_id] = (!entry.lastTenDay && dataDictionary[entry.animal_id] && dataDictionary[entry.animal_id].lastTenDay) ? {...entry, lastTenDay: dataDictionary[entry.animal_id].lastTenDay}: entry)
    const newPayload = {con, data: Object.values(dataDictionary)}
    if (newPayload.data.length !== existingData.length || !isEqual(existingData, newPayload.data) ) {
      animalsDataAdapter.upsertOne(state, newPayload);
    }
  } else { animalsDataAdapter.addOne(state, {con, data})}
}

const updatePayloadAndState = (state: EntityState<AnimalItem, string>, {con, data}: AnimalItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const dataDictionary = keyBy(state.entities[identifier].data, "feedCurveId")
    data.forEach((entry) => dataDictionary[entry.animal_id] = merge({}, entry, dataDictionary[entry.animal_id]));
    const newPayload = {con, data: Object.values(dataDictionary)}
    animalsDataAdapter.upsertOne(state, newPayload);
  } else { animalsDataAdapter.addOne(state, {con, data})}
}

const removeDeletedFromState = (state: EntityState<AnimalItem, string>, {con, data}: AnimalItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const idsToRemove = data.map((animal) => (animal.animal_id));
    const newPayload = {con, data: state.entities[identifier].data.filter((animal) => !idsToRemove.includes(animal.animal_id))}
    animalsDataAdapter.upsertOne(state, newPayload);
  }
}

/**
 * @deprecated
 */
const animalSlice = createSlice({
  name: "animals/old",
    initialState: animalsDataAdapter.getInitialState<AnimalItem[]>([]),
      reducers: {
        maintained: (state, {payload}:PayloadAction<AnimalItem>) => {
          mergePayloadAndState(state, payload);
        },
        update: (state, {payload}: PayloadAction<AnimalItem>) => {
          updatePayloadAndState(state, payload);
        },
        deleted: (state, {payload}) => {
          removeDeletedFromState(state, payload)
        }
    }
})

/**
 * @deprecated
 */
export const AnimalActions = animalSlice.actions;
export default animalSlice.reducer;